/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { KeyType } from '../../models/key-type';
import { UserForOrganizationAdminRequest } from '../../models/user-for-organization-admin-request';

export interface PostAdministrationOrganizationUser$Params {
  organizationKey: KeyType;
      body: UserForOrganizationAdminRequest
}

export function postAdministrationOrganizationUser(http: HttpClient, rootUrl: string, params: PostAdministrationOrganizationUser$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, postAdministrationOrganizationUser.PATH, 'post');
  if (params) {
    rb.path('organizationKey', params.organizationKey, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

postAdministrationOrganizationUser.PATH = '/administration/organizations/{organizationKey}/users';
